import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes

import { Icon } from "@mui/material";

import styles from "../../assets/jss/material-kit-pro-react/components/infoStyle.js";
import { getBaseSxStyle, getKeyArray } from "../../utils/getSxStyle.js";


export default function InfoArea(props) {
  const { title, description, iconColor, vertical, className } = props;

  const iconData = {
    "iconWrapper": true,
    [iconColor]: true,
    "iconWrapperVertical": vertical
  };
  const iconDataKeys = getKeyArray(iconData);


  const iconDataBase = {
    "icon": true,
    "iconVertical": vertical
  };
  const iconDataBaseKeys = getKeyArray(iconDataBase);


  const infoAreaData = {
    "infoArea": true,
  };
  const infoAreaKeys = getKeyArray(infoAreaData);

  let icon = null;

  switch (typeof props.icon) {
    case "string":
      icon = <Icon sx={getBaseSxStyle(styles, iconDataBaseKeys)}>{props.icon}</Icon>;
      break;
    default:
      icon = <props.icon sx={getBaseSxStyle(styles, iconDataBaseKeys)} />;
      break;
  };

  return (
    <div style={getBaseSxStyle(styles, infoAreaKeys)}>

      <div style={getBaseSxStyle(styles, iconDataKeys)}>
        {icon}
      </div>

      <div sx={styles.descriptionWrapper}>
        <h4 sx={styles.title}>{title}</h4>
        <div sx={styles.description}>{description}</div>
      </div>

    </div>
  );
}

InfoArea.defaultProps = {
  iconColor: "gray"
};

InfoArea.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.node.isRequired,
  iconColor: PropTypes.oneOf([
    "primary",
    "warning",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
  ]),
  vertical: PropTypes.bool,
  className: PropTypes.string
};
